import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/manga";

export default function CategoryNav() {
  const location = useLocation();

  return (
    <section className="py-8 md:py-10 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 mt-1 line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}